module.exports = __webpack_public_path__ + "static/img/case3.a36b44fb.jpg";